var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slds-grid slds-wrap"},[_c('gnetTable',{attrs:{"wrapheader":true,"cols":_vm.cols,"records":_vm.rows},on:{"xfilter":function($event){return _vm.filterCol($event)},"xrow":function($event){return _vm.filterRow($event)},"click":function($event){return _vm.gotoRecord($event)}}}),_c('spinner',{attrs:{"busy":_vm.busy}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }